// Pulse citation chip -> the chart tab that shows the cited item, in care's
// NavFrame tab ids (patientchartwrap renderContent): Labs 1, Documents 2,
// Prior visits 5, Medications 9, CareIQ 11. (The panel came from cloud2, whose
// CareIQ tab id differs; Imaging (6) is not a listed tab here, its reports
// file under Documents.) Returns null for an unknown type.
import { chartTabAllowed } from "../../../config/practice";

const REF_TABS = {
  lab: 1,
  imaging: 2,
  encounter: 5,
  medication: 9,
  condition: 11,
};

// The tab to open for `ref` on this chart: the mapped tab when this practice's
// chart lists it, else CareIQ when listed (7825's N3 chart has no Labs /
// Documents / Prior visits / Medications tabs), else null (stay put).
export function pulseRefTab(ref, careiqN3) {
  const want = REF_TABS[ref?.type];
  if (want == null) return null;
  if (chartTabAllowed(want, careiqN3)) return want;
  if (chartTabAllowed(11, careiqN3)) return 11;
  return null;
}

// Pulse "pull up" action (v2 pulse_actions.py) -> care tab id. open_tab names a
// tab by key; open_lab_trend opens Labs; open_document opens Documents (the
// document itself opens in PulseChat's viewer, this is only the tab behind it).
// A tab this chart does not list falls back like a citation (CareIQ, else null).
const ACTION_TABS = {
  labs: 1,
  documents: 2,
  vitals: 3,
  rpm: 4,
  prior_visits: 5,
  forms: 7,
  medications: 9,
  careiq: 11,
};

// Auto-run only when the action's own tab is listed on this chart (review 10-22): an open_document on a chart
// without Documents (7825's N3 chart) stays a button and never opens by itself.
export function pulseActionAutoOk(action, careiqN3) {
  if (!action) return false;
  const key = action.type === "open_lab_trend" ? "labs"
    : action.type === "open_document" ? "documents"
      : action.type === "open_tab" ? action.tab : null;
  const want = ACTION_TABS[key];
  return want != null && Boolean(chartTabAllowed(want, careiqN3));
}

export function pulseActionTab(action, careiqN3) {
  if (!action) return null;
  const key = action.type === "open_lab_trend" ? "labs"
    : action.type === "open_document" ? "documents"
      : action.type === "open_tab" ? action.tab : null;
  const want = ACTION_TABS[key];
  if (want == null) return null;
  if (chartTabAllowed(want, careiqN3)) return want;
  if (chartTabAllowed(11, careiqN3)) return 11;
  return null;
}
